import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['Domingo a la noche buscando actividades que nunca quedan bien', 'Clases sin estructura porque no tenés guion ni experiencias listas', 'Evaluaciones inventadas porque no tenés criterios ni rúbricas', 'Horas perdidas adaptando materiales que no están hechos para tu nivel', 'Alumnos que no enganchan porque el contenido no conecta con nada real', 'Feria de ciencias a las corridas sin proyecto ni guía clara'];
  return <section className="bg-brand-dark py-16 md:py-24 px-4 border-t border-brand-border" data-id="element-197">
      <div className="max-w-3xl mx-auto" data-id="element-198">
        <motion.h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-white text-center mb-10 md:mb-14 leading-snug px-2" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-199">
          Si sos docente de Física o Química en secundaria,
          <br data-id="element-200" />
          <span className="text-brand-accent" data-id="element-201">
            esto te va a sonar familiar:
          </span>
        </motion.h2>

        <div className="space-y-4 md:space-y-5 mb-14 md:mb-16" data-id="element-202">
          {painPoints.map((point, index) => <motion.div key={index} className="flex items-center gap-4 md:gap-5 py-5 md:py-6 px-5 md:px-7 rounded-2xl bg-[#2a1a1a] border border-[#5a4a2a] hover:border-brand-accent/40 transition-colors" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} data-id="element-203">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 bg-brand-red/20 rounded-lg flex items-center justify-center" data-id="element-204">
                <X size={20} className="text-brand-red md:w-6 md:h-6" strokeWidth={3} data-id="element-205" />
              </div>
              <p className="text-base sm:text-lg md:text-xl text-white/90 font-semibold leading-snug" data-id="element-206">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="text-center px-4" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-207">
          <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold leading-tight italic text-[#FF1E00]" data-id="element-208">
            ¿Cuántos domingos más vas a perder haciendo lo mismo?
          </p>
        </motion.div>
      </div>
    </section>;
}